import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import ReactDOM from "react-dom"
import Router from "@/routers/Router";
import '@/assets/css/global.less?v=1'

import { Provider } from "react-redux"
import store from '@/store'

ReactDOM.render(<Provider store={store}><Router /></Provider>
    , document.getElementById("root"))